import $ from 'jquery';

function subMenuToggle() {
  // Hide all sub-menus initially.
  $('.menu .sub-menu-toggle').each(function () {
    $(this).next('ul').hide();
  });

  // Toggle on click.
  $(document).on('click.sub-menu-toggle', '.menu .sub-menu-toggle', function () {
    var $btn = $(this);
    var $subMenu = $btn.next('ul');

    if ($subMenu.is(':hidden')) {
      $btn.addClass('is-open').attr('aria-expanded', 'true');
      $subMenu.slideDown();
    } else {
      $subMenu.slideUp(null, function () {
        $btn.removeClass('is-open').attr('aria-expanded', 'false');
      });
    }

    return false;
  });
}

export default subMenuToggle;
